@if (form) {
  <form class="action-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
    <span class="title">{{ dataContext.title | translate }}</span>
    <section class="astral-section-surface astral-section-surface--compact">
      <astral-select
        [itemsSource]="dataContext.itemsSource"
        [control]="form.controls['property']"
        [helpText]="dataContext.helpText"
      ></astral-select>
    </section>
    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" labelKey="OK_BTN"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
